enum MARKS {
	MARKS = '/api/archive/marks',
	MARKS_BY_ID = '/api/archive/marks/',
	UPLOAD_MARKS = '/api/archive/marks/uploadStudentMarks',
	EXPORT_MARKS_XLSX = '/api/archive/marks/export/xlsx'
}

enum COMMANDS {
	COMMANDS = '/api/archive/commands',
	UPLOAD_COMMANDS = '/api/archive/commands/uploadCommands'
}

export default {
	MARKS,
	COMMANDS
};
